module.exports = __webpack_public_path__ + "460ee18f07b123c7fffd9cc351502dea.svg";